import PropTypes from "prop-types";
import React from "react";

import Icon from "../interface/Icon";
import { withOptionalTooltip } from "../interface/Tooltip";

const TabButton = props => {
  const btn = (
    <div className={`tabButton ${props.active ? "active" : ""}`} onClick={props.onClick}>
      {props.icon ? <Icon icon={props.icon} pulse={props.pulse} /> : null}
      {props.showLabel ? <span className="tabLabel">{props.label}</span> : null}
      {props.badge ? <span className={`badge ${props.badgeColor}`}>{props.badge}</span> : null}
    </div>
  );

  return withOptionalTooltip(btn, props.label, { placement: "bottom-start" });
};

TabButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string,
  badge: PropTypes.number,
  badgeColor: PropTypes.string,
  label: PropTypes.string.isRequired,
  showLabel: PropTypes.bool,
  active: PropTypes.bool.isRequired,
  pulse: PropTypes.bool
};

export default TabButton;
